var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort-head",class:{'is-active': _vm.isFilterActive()},on:{"click":function($event){return _vm.setOrderSortFilter()}}},[_vm._t("default"),_c('b-icon',{attrs:{"icon":"caret-down-fill"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }